import React from 'react'

export const IconSize = {
  // size 38 x 38
  Small: {
    height: 38,
    width: 38,
    fontSize: 16
  },
  // size 80 x 80
  Large: {
    height: 80,
    width: 80,
    fontSize: 32
  }
}

export const IconShape = {
  Circular: 0,
  Squared: 1
}

const buildInitials = (source) => {
  return source.split(' ').map(x => x.charAt(0).toUpperCase()).join('')
}

const memberIconShapeStyles = (member, size) => ({
  flexGrow: 0,
  flexShrink: 0,
  height: size.height,
  width: size.width,
  borderRadius: 40,
  fontSize: size.fontSize,
  fontWeight: 500,
  background: member.color,
  lineHeight: `${size.height}px`,
  color: 'white',
  textAlign: 'center'
})

export const MemberIcon = ({ member, style, size = IconSize.Small, shape = IconShape.Circular }) =>
  <div style={style}>
    <div style={memberIconShapeStyles(member, size, shape)}>
      {buildInitials(member.displayName)}
    </div>
  </div>

export default MemberIcon


// WEBPACK FOOTER //
// ./src/team/MemberIcon.js